import { createPortal } from "react-dom";

export function printNow(format) {
  let el = document.getElementById("page-size-style");
  if (!el) {
    el = document.createElement("style");
    el.id = "page-size-style";
    document.head.appendChild(el);
  }
  el.textContent = format === "thermal" ? "@page { size: 80mm auto; margin: 4mm 6mm; }" : "@page { size: A4; margin: 12mm; }";
  setTimeout(() => window.print(), 80);
}

export const PrintPortal = ({ children }) => createPortal(<div className="print-root">{children}</div>, document.body);
